import React, {useEffect, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {useGetEdges} from "../../api/get-edges";
import Box, {Item} from "devextreme-react/box";
import {NumberBox} from "devextreme-react/number-box";
import {SelectedMaterial} from "../../types/SelectedMaterial";
import Validator from "devextreme-react/validator";
import {CustomRule} from "devextreme-react/form";
import {formatNumber} from "devextreme/localization";

export function EdgesLineControl({ group }: { group: SelectedMaterial }) {
    const context = useCountertops();
    const edges = useGetEdges(context.dealerId, group.prodQteGrpID ?? 0, context.estimateDate, context.customerZip);
    const [selectedEdges, setSelectedEdges] = useState<Map<number, number | undefined>>(new Map<number, number | undefined>());

    useEffect(() => {
        let map = new Map<number, number | undefined>();
        group.edges.forEach(item => {
            map.set(item.productID, item.length);
        });

        setSelectedEdges(map);
    }, [group.edges])

    if (edges.isLoading)
        return <></>

    return (
        <>
            <p className={"group-name"}>{group.name}</p>
            <Box style={{ columnGap: '20px', marginBottom: '10px', rowGap: '20px' }} elementAttr={{ class: "edges" }}>
                {edges.data.map(edge =>
                    <Item key={edge.productID} baseSize={165}>
                        <img src={edge.imageUrl} />
                        <p style={{ flex: 'auto' }}>{edge.name} </p>
                        <Box direction={'row'} crossAlign={"center"}>
                            <Item baseSize={100}>
                                <NumberBox
                                    stylingMode='outlined'
                                    inputAttr={{ "style": "text-align:center" }}
                                    width={'100px'}
                                    value={selectedEdges.get(edge.productID)}
                                    valueChangeEvent='blur'
                                    onValueChanged={(e) => {
                                        if (e.event) {
                                            context.updateEdge(group.prodQteGrpID, edge.productID, e.value ?? undefined)
                                        }
                                    }}
                                >
                                    <Validator>
                                        <CustomRule message={"Quantity must be set and greater than 0"}
                                            validationCallback={context.qtyValidationNotMandatory}></CustomRule>
                                    </Validator>
                                </NumberBox>
                            </Item>
                            <Item baseSize={50}>
                                &nbsp;ln. in. 
                            </Item>
                        </Box>
                        {context.showPrices && (edge.amount !== null) ?
                            <span style={{textAlign:"center", paddingRight:"50px"}}>{formatNumber(edge.amount, "currency")} / ln. in</span> : <></>}
                    </Item>
                )}
            </Box>
        </>
    );
}
